import { render } from "./EditPenIcon.vue?vue&type=template&id=5545c202"
import script from "./EditPenIcon.vue?vue&type=script&lang=js"
export * from "./EditPenIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__